module.exports = __webpack_public_path__ + "img/8b7ec67320a2b928c4398d68f04116fa.e4151db6.png";